import React from 'react'
import { FormTitleText } from '../styledComponents'

export const FormTitle = ({ title }) => <FormTitleText>{title}</FormTitleText>
